import Vue from 'vue'
import { USER_INFO } from '@/store/variables'

const getters = {
  token: state => state.user.token,
  language: state => state.app.language,
  avatar: state => { state.user.avatar = Vue.ls.get(USER_INFO).avatar; return state.user.avatar },
  username: state => state.user.username,
  nickname: state => { state.user.nickname = Vue.ls.get(USER_INFO).nickname; return state.user.nickname },
  resources: state => state.user.resources,
  userInfo: state => { state.user.info = Vue.ls.get(USER_INFO); return state.user.info }
}
export default getters
